import CategoryIcon from '@mui/icons-material/Bookmark';

import CategoryList from './CategoryList';

export default {
    list: CategoryList,
    icon: CategoryIcon,
};
